<template>
  <button class="btn btn-loading" :disabled="loading" :class="[{ 'btn-loading--disabled' : loading, 'loading' : loading }]" @click="$emit('click')">
    <span class="btn__content">
      <span v-if="loading" class="btn-icon-prepend text-primary">
        <font-awesome-icon icon="spinner" spin />
      </span>
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'ButtonLoading',
  props: ['loading'],
};
</script>

<style lang="scss" scoped>
.btn-loading--disabled {
  .btn__content {
    opacity: 0.8;
  }
}
.btn-loading {
  position: relative;
  padding-left: $padding;
  padding-right: $padding;
  &.loading {
    padding-left: $padding * 2;
  }
}
.btn-icon-prepend {
  position: absolute;
  left: $padding;
}
</style>
